import { render, staticRenderFns } from "./LmList.vue?vue&type=template&id=531deb3a&scoped=true&"
import script from "./LmList.vue?vue&type=script&lang=js&"
export * from "./LmList.vue?vue&type=script&lang=js&"
import style0 from "./LmList.vue?vue&type=style&index=0&id=531deb3a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531deb3a",
  null
  
)

export default component.exports